module.exports = __webpack_public_path__ + "img/1.07.thmb.826965b6.jpg";